export const parseDocumentId = (state, request) => {
  const documents = {};

  if (request.value === 'reset') {
    return documents;
  }

  if (
    state.documentIds &&
    Object.keys(state.documentIds) &&
    Object.keys(state.documentIds).length > 0
  ) {
    Object.keys(state.documentIds).filter(key => {
      documents[`${key}`] = state.documentIds[key];
      return true;
    });
  }
  documents[`${request.id}`] = request.value;

  return documents;
};

export const parseDocumentLoading = (state, request) => {
  const documentLoading = {};

  Object.keys(state.isDocumentUploading).filter(key => {
    documentLoading[`${key}`] = state.isDocumentUploading[key];
    return true;
  });
  documentLoading[`${request.model}`] = request.value;

  return documentLoading;
};
